var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v("Mortgage Tax")]),_c('TransactionList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }